import {
  Typography,
  Stack,
  Box,
  Avatar,
} from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';

export default function FliersPositionCards({ groups=[], selectGroup }) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Box
      sx={{
        mt: 2,
        py: 2,
        display: 'grid',
        gap: smUp ? 4 : 2.5,
        rowGap: 3,
        gridTemplateColumns: {
          xs: 'repeat(4, 1fr)',
          md: 'repeat(8, 1fr)',
          lg: 'repeat(8, 1fr)',
        },
      }}
    >
      {groups.map((group, index) => (
      <Stack key={index} alignItems={"center"}
        sx={{
          width: 1,
          '&:hover': {
            cursor: 'pointer',
          },
        }}
        spacing={smUp ? 2 : 1}
        onClick={() => selectGroup(group)}
      >
        <Avatar
          src={group.image_url}
          sx={{
            width: smUp ? 80 : 48,
            height: smUp ? 80 : 48,
            '&:hover': {
              boxShadow: (theme) => theme.customShadows.z8,
            },
          }}
        />
        <Typography variant={smUp ? "subtitle1" : "body2"}>
          {group.name}
        </Typography>
      </Stack>
      ))}
    </Box>
  )
}
